import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";

function formatDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return `${String(date.getDate()).padStart(2, "0")}/${String(
    date.getMonth() + 1
  ).padStart(2, "0")}/${date.getFullYear()} ${String(
    date.getHours()
  ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
}

export default function MailClassificationDialog({
  open,
  onClose,
  onSearch,
  searchResults,
  selectedThreadId,
  onSelectThread,
  onDiscard,
  onAssign,
  loading,
}) {
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (open) {
      setSearchValue("");
      onSearch("");
    }
  }, [onSearch, open]);

  return (
    <Dialog open={open} onClose={() => !loading && onClose()} fullWidth maxWidth="md">
      <DialogTitle>Clasificar mail pendiente</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          margin="normal"
          variant="outlined"
          label="Buscar thread por asunto"
          value={searchValue}
          onChange={(event) => {
            const nextValue = event.target.value;
            setSearchValue(nextValue);
            onSearch(nextValue);
          }}
          InputLabelProps={{ shrink: true }}
        />
        <List style={{ maxHeight: "340px", overflowY: "auto", border: "1px solid #E4E6EF", borderRadius: "0.42rem" }}>
          {searchResults.map((thread) => (
            <ListItem
              key={thread.mail_thread_id}
              button
              selected={selectedThreadId === thread.mail_thread_id}
              onClick={() => onSelectThread(thread.mail_thread_id)}
              divider
            >
              <ListItemText
                primary={thread.asunto || `Thread ${thread.mail_thread_id}`}
                secondary={`${thread.remitente || "Sin remitente"}${thread.fecha_ultimo_mail ? ` · ${formatDate(thread.fecha_ultimo_mail)}` : ""}`}
              />
            </ListItem>
          ))}
          {!searchResults.length && (
            <ListItem>
              <ListItemText primary="No hay threads para mostrar." />
            </ListItem>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button onClick={onDiscard} disabled={loading} color="secondary" variant="outlined">
          Descartar
        </Button>
        <Button
          onClick={onAssign}
          disabled={!selectedThreadId || loading}
          color="primary"
          variant="outlined"
        >
          Asignar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
